import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectAddressSearchRetrieval = createSelector(
  [(state: AppState) => state.shared.addressSearchRetrieval],
  ({ data, fetching }) => ({ data, fetching }),
);
